import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { Camera, X } from 'lucide-react';

// agent-driven UI: glowing pointer on a button, big camera button (camera needs one real tap)
export default function AgentPointer({ t }) {
  const [ui, setUi] = useState(null);
  const [box, setBox] = useState(null);
  useEffect(() => {
    const on = (e) => setUi({ ...e.detail, at: Date.now() });
    window.addEventListener('giss-agent-ui', on);
    return () => window.removeEventListener('giss-agent-ui', on);
  }, []);
  useEffect(() => {
    if (ui?.kind !== 'point') { setBox(null); return undefined; }
    const el = document.querySelector(`[data-testid="${ui.testid}"]`);
    const target = el?.type === 'file' || el?.hidden ? el.closest('label') || el.parentElement : el;
    if (!target) { setUi(null); return undefined; }
    target.scrollIntoView({ block: 'center', behavior: 'smooth' });
    const upd = () => setBox(target.getBoundingClientRect());
    const iv = setInterval(upd, 250), end = setTimeout(() => setUi(null), 9000), off = () => setUi(null);
    upd();
    window.addEventListener('pointerdown', off, true);
    return () => { clearInterval(iv); clearTimeout(end); window.removeEventListener('pointerdown', off, true); };
  }, [ui]);
  if (!ui) return null;
  if (ui.kind === 'photo') {
    const go = () => {
      if (ui.target === 'moisture') document.querySelector('[data-testid="moist-cam-input"]')?.click();
      else window.dispatchEvent(new CustomEvent('giss-agent-camera', { detail: ui.target }));
      setUi(null);
    };
    return createPortal(
      <div className="ag-photo" data-testid="agent-photo-overlay">
        <button className="ag-photo-btn" data-testid="agent-photo-btn" onClick={go}><Camera size={34} /><span>{ui.hint || t.agPhoto}</span></button>
        <button className="icon-btn ag-photo-x" data-testid="agent-photo-cancel" onClick={() => setUi(null)}><X size={18} /></button>
      </div>, document.body);
  }
  if (!box) return null;
  return createPortal(
    <div className="ag-point" data-testid="agent-pointer" style={{ left: box.left - 6, top: box.top - 6, width: box.width + 12, height: box.height + 12 }}>
      {ui.hint && <span className="ag-hint" data-testid="agent-pointer-hint">{ui.hint}</span>}
    </div>, document.body);
}

// checklist of a guided workflow (agent tool show_steps)
export function AgentSteps({ t }) {
  const [s, setS] = useState(null);
  useEffect(() => { const on = (e) => setS(e.detail); window.addEventListener('giss-agent-steps', on); return () => window.removeEventListener('giss-agent-steps', on); }, []);
  if (!s) return null;
  return createPortal(
    <div className="ag-steps" data-testid="agent-steps">
      <div className="ag-steps-head"><b>{s.title || t.agSteps}</b><button className="icon-btn" data-testid="agent-steps-close" onClick={() => setS(null)}><X size={16} /></button></div>
      <ol>{s.steps.map((x, i) => <li key={x + i} data-testid={`agent-step-${i + 1}`} className={i + 1 < s.current ? 'done' : i + 1 === s.current ? 'cur' : ''}>{x}</li>)}</ol>
    </div>, document.body);
}
